<template>
  <DBox
    :id="'cmp-royalty-contracts-sidewindow-contract_balances'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add')} ${$dft.capSnake(channel)}`"
    @add_click="onAddContractBalances"
  >
    <!-- :addLinkLabel="
      `${$t('add')} ${$t('new')} ${$dft.capHead(channel)} ${$t('item')}`
    " -->
    <NTable
      class="dbox1"
      id="royalty-contracts-sidewindow-contract_balances-list"
      :config="tableConfig"
      :headers="headers"
      :items="list || []"
      :showNoItems="false"
      @scrollnext="onListScroll"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('recoupables')">
            <DatePicker2
              id="balance_date"
              :label="$t('balance_date')"
              :showLabel="false"
              :value="item['balance_date']"
              :bb="'0px'"
              @input="(e) => onDateUpdate(e, item)"
            />
          </td>
          <td v-bind="tdcon('description')">
            <TextField2
              class="dbox1"
              :id="'description'"
              :showLabel="false"
              :value="item['description']"
              @blur="(e) => onTextFieldValueChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('balance_type')">
            <!-- [{text: 'one', value: 1}, 
              {text: 'two', value: 2}] -->
            <Dropdown2
              class="dbox1"
              :showLabel="false"
              :options="balanceTV"
              :selected="balanceTV.find((e) => e.value == item.balance_type)"
              :placeholder="$t('balance_type')"
              v-on:selectedChange="
                (e) => onDropdownChange('balance_type', e, item)
              "
              :bb="'0px'"
            />
          </td>
          <td v-bind="tdcon('amount')">
            <div class="amount-currency">
              <TextField2
                class="dbox1"
                :ta="'right'"
                :id="'amount'"
                :type="'number'"
                :showLabel="false"
                :value="item['amount']"
                @blur="(e) => onTextFieldValueChange(e, item)"
              />

              <span class="amount-text">EUR</span>
            </div>
          </td>
          <td v-bind="tdcon('options')">
            <img
              src="static/icons/delete.svg"
              @click.stop="(e) => onDeleteCarriedOver(item)"
              class="dt-icon v5 s1 ut-center"
              alt
            />
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { ContractsService } from "../../services/contracts.service";
import { isValidNumber, subscribeSubject } from "../../../../utility";
import { Subject } from "rxjs";
export default {
  components: {
    DBox,
    NTable,
  },
  props: ["mechanicalFlag", "channel", "list", "balanceTV"],
  data: function () {
    return {
      type: "",
      scrollSubject: new Subject(),
      start: 0,
    };
  },
  computed: {
    tableConfig: function () {
      return createNTableConfig({
        headerStyle: 3,
        scrollNextThreshold: 95,
      });
    },
    headers: function () {
      return [
        createTableHeader("recoupables", {
          text: this.$dft.capSnake(this.channel),
          mw: 115,
        }),
        createTableHeader("description"),
        createTableHeader("balance_type"),
        createTableHeader("amount"),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },
    contract_id: function () {
      return this.$route.params.contract_id;
    },
  },
  async mounted() {
    console.log('contact_balance')
    subscribeSubject(this, this.scrollSubject, (res) => {
      const type_str = "1,2,3,4";
      ContractsService.fetchDetailsTabBalances(
        this.contract_id,
        type_str,
        res.start
      ).then((res) => {
        this.$emit("fetch", { ...res.data, channel: this.channel });
      });
    });
  },
  methods: {
    onTextFieldValueChange: function ({ name, value }, item) {
      this.$emit("changed", { name, value, item });
    },

    onDateUpdate: function ({ name, value }, item) {
      this.$emit("changed", {
        name,
        value,
        item,
      });
    },

    onDropdownChange: function (name, e, item) {
      this.$emit("changed", { name, value: e.value, item });
    },

    // onAddCarriedOver: async function() {
    //     if(this.channel == )
    //   const res = await ContractsService.addContractBalance({
    //     contract_id: this.contract_id,
    //     type: "34"
    //   });
    //   console.log("onAddCarriedOver ", res.data);
    //   this.$emit("added", res.data);
    // },

    onAddContractBalances: async function () {
      if (this.channel == "recoupables") {
        this.type = "12";
      } else {
        this.type = "34";
      }

      const res = await ContractsService.addContractBalance({
        contract_id: this.contract_id,
        type: this.type,
      });
      console.log("onAddContractBalances ", res.data, "this.type ", this.type);
      this.$emit("added", { ...res.data, channel: this.channel });
    },
    onListScroll: function (value) {
      console.log("OOO");
      this.start = this.start + 30;
      this.scrollSubject.next({ start: this.start });
    },
    onDeleteCarriedOver: async function (item) {
      const confirmationResult = await confirmDelete(
        "description",
        item.description
        // this.$dft.capSnake(this.channel),
        // item.balance_id
      );
      if (confirmationResult === "OK") {
        this.$emit("deleted", { ...item, channel: this.channel });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cmp-royalty-contracts-sidewindow-contract_balances {
  .royalty-contracts-sidewindow-contract_balances-list {
    &.dt-ntable {
      //   --ntable-height: 170px;
    }
    .amount-currency {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-left: 3px !important;
      margin-left: 3px !important;

      .fc2-textfield {
        flex: 1;
        width: 50%;
      }

      .amount-text {
        display: block;
      }
    }
  }
}
</style>
